<div (offClick)="dismiss()" class="visit-tutorial">
  <div class="form-instructions">
    <div class="row">
      <div class="col-lg-12">
        <strong>
          Here's where to find your {{loyaltyMode == LoyaltyMode.Points ? ' ': 'visit '}}details -
        </strong>
        <ol class="list">
          <li><span>Date of Order</span></li>
          <li><span>Order Number</span></li>
          <li><span>Order Total</span></li>
        </ol>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 receipt-image">
      <img src="../../../../assets/images/add-visit/receipt-image.svg" alt="add visit tutorial" />
    </div>
  </div>
</div>